import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustMetrics from "@/components/TrustMetrics";
import About from "@/components/About";
import WhyUs from "@/components/WhyUs";
import Industries from "@/components/Industries";
import Process from "@/components/Process";
import Insights from "@/components/Insights";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <div
      data-testid="zx-home"
      className="relative min-h-screen bg-[#0B0B0B] text-white overflow-x-hidden"
    >
      {/* Ambient background layers */}
      <div className="pointer-events-none fixed inset-0 -z-10">
        <div className="absolute inset-0 zx-grid opacity-40" />
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(900px 600px at 85% -5%, rgba(217,249,157,0.07), transparent 60%), radial-gradient(800px 500px at 5% 15%, rgba(167,139,250,0.07), transparent 60%), radial-gradient(900px 600px at 95% 55%, rgba(96,165,250,0.06), transparent 60%), radial-gradient(800px 500px at 10% 80%, rgba(253,186,116,0.05), transparent 60%), radial-gradient(900px 600px at 50% 115%, rgba(217,249,157,0.05), transparent 60%)",
          }}
        />
        {/* Soft blobs */}
        <div className="zx-blob zx-float" style={{ top: "6%", left: "-6%", width: 460, height: 460, background: "radial-gradient(circle, rgba(167,139,250,0.22), transparent 70%)", filter: "blur(90px)", opacity: 0.55 }} />
        <div className="zx-blob zx-float" style={{ top: "35%", right: "-8%", width: 540, height: 540, background: "radial-gradient(circle, rgba(96,165,250,0.18), transparent 70%)", filter: "blur(90px)", opacity: 0.55, animationDelay: "2s" }} />
        <div className="zx-blob zx-float" style={{ bottom: "-6%", left: "30%", width: 580, height: 580, background: "radial-gradient(circle, rgba(217,249,157,0.14), transparent 70%)", filter: "blur(90px)", opacity: 0.55, animationDelay: "4s" }} />
      </div>

      <a
        href="#main-content"
        className="zx-skip-link"
        data-testid="skip-to-content"
      >
        Skip to content
      </a>
      <Header />
      <main id="main-content" className="space-y-2">
        <Hero />
        <SectionDivider />
        <TrustMetrics />
        <SectionDivider />
        <About />
        <SectionDivider />
        <WhyUs />
        <SectionDivider />
        <Industries />
        <SectionDivider />
        <Process />
        <SectionDivider />
        <Insights />
        <SectionDivider />
        <Testimonials />
        <SectionDivider />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function SectionDivider() {
  return (
    <div
      aria-hidden
      data-testid="section-divider"
      className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-4 sm:py-6"
    >
      {/* Soft ambient glow behind the line */}
      <div
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-4 w-2/3 rounded-full pointer-events-none"
        style={{
          background:
            "radial-gradient(60% 120% at 50% 50%, rgba(217,249,157,0.18), rgba(217,249,157,0) 70%)",
          filter: "blur(6px)",
        }}
      />
      {/* Premium luminous divider — matches the footer accent line */}
      <div
        className="relative h-px w-full"
        style={{
          background:
            "linear-gradient(90deg, transparent 0%, rgba(217,249,157,0.45) 50%, transparent 100%)",
        }}
      />
    </div>
  );
}
